<template>
  <div>
    <div class="bg" />
    <div id="divider" />
    <form
      novalidate
      class="md-layout md-alignment-center margin-sides"
      @submit.prevent="validateUser"
    >
      <md-card
        class="md-layout-item md-size-35 md-small-size-90"
        style="background:white; direction: rtl;"
      >
        <md-card-header>
          <div class="md-title">הזנת קוד הפעלה</div>
        </md-card-header>

        <md-card-content class="pad-sides">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('serial')">
                <label for="serial">קוד הפעלה</label>
                <md-input
                  name="serial"
                  id="serial"
                  autocomplete="serial"
                  v-model="form.serial"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.serial.required">קוד הפעלה נדרש</span>
                <span class="md-error" v-else-if="!$v.form.serial.minlength">קוד הפעלה לא תקין</span>
              </md-field>
            </div>
          </div>
        </md-card-content>

        <md-card-content class="pad-sides" style="font-size: 18px">
          <div>{{licenseLength}}</div>
          <div>{{licenseValidity}}</div>
        </md-card-content>
        <md-progress-bar md-mode="indeterminate" v-if="sending" />

        <md-card-actions>
          <md-button
            type="submit"
            class="confirm-btn md-primary md-raised"
            :disabled="sending"
          >הפעל סריאל</md-button>
        </md-card-actions>
      </md-card>
      <md-snackbar
        :md-active.sync="userSaved"
      >הסריאל הופעל בהצלחה. ניתן לחזור למסך האפליקציה אם אינך מועבר אוטומטית</md-snackbar>
      <md-snackbar :md-active.sync="showError">{{this.errorMsg}}</md-snackbar>
    </form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { checkIfInMoile, isDebug } from "../helpers/utils.js";
import { devAppUrl, prodAppUrl } from "../global/config.json";
import axios from "axios";

const exectLength = length => value => value.length === length;
// eslint-disable-next-line
const analytics = firebase.analytics()

export default {
  name: "FormValidation",
  mixins: [validationMixin],
  data: () => ({
    form: {
      serial: null
    },
    licenseLength: null,
    licenseValidity: null,
    userSaved: false,
    sending: false,
    lastUser: null,
    errorMsg: null,
    showError: false
  }),
  created() {
    analytics.logEvent("screen_view", {
      screen_name: "Serial Screen"
    });
  },
  validations: {
    form: {
      serial: {
        required,
        minLength: 9
      }
    }
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
    clearForm() {
      this.$v.$reset();
      this.form.serialCode = null;
    },
    async saveUser() {
      this.sending = true;

      const token = this.$cookies.get("token");
      const { serial } = this.$data.form;

      axios
        .post(
          "https://us-central1-tzav-rishon.cloudfunctions.net/activateAppWithSerialV2",
          {
            user_token: token,
            serial
          }
        )
        .then(result => {
          if (result.status) {
            this.userSaved = true;
            this.clearForm();
            if (!checkIfInMoile()) {
              window.location.href = isDebug() ? devAppUrl : prodAppUrl;
            }
          } else {
            this.errorMsg = result.message || "לא בוצעה רכישה";
            this.showError = true
          }
        })
        .catch(err => {
          this.errorMsg = err.response.data.message || "לא בוצעה רכישה";
          this.showError = true;
        })
        .finally(() => {
          this.sending = false;
        });
    },
    validateUser() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.saveUser();
      }
    }
  }
};
</script>

<style scoped>
.margin-sides {
  margin-right: 2vw;
  margin-left: 2vw;
}

.pad-sides {
  padding-left: 48px;
  padding-right: 48px;
}

#divider {
  height: 18vh;
}
.form {
  margin-top: 32px;
}
#title {
  top: 4vh;
  width: 100%;
  color: white;
  font-size: 48px;
}

.bg {
  background-image: url(https://storage.googleapis.com/tzav-rishon-web-assets/blurred_backpacks_bg.png);
  background-size: cover;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  position: absolute;
}

.confirm-btn {
  height: 50px;
  width: 40%;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-bottom: 8px;
}
</style>